module.exports = "/_next/static/images/CustomizeData@2x-1eaa3e0d2d72c05420664849817d6c44.webp";